import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/tab-navigation.css';

const TabNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      id: 'consult',
      path: '/form-v2',
      icon: '/nav_record.png',
      label: '相談',
    },
    {
      id: 'chat',
      path: '/chat',
      icon: '/chat.png',
      label: 'チャット',
    },
    {
      id: 'recipes',
      path: '/recipe-hub',
      icon: '/nav_recipe.png',
      label: 'レシピ',
    },
    {
      id: 'mypage',
      path: '/mypage',
      icon: '/nav_settings.png',
      label: 'マイページ',
    },
  ];

  const isActive = (path) => {
    // レシピタブの特別処理：レシピ関連の複数パスをチェック
    if (path === '/recipe-hub') {
      const recipeRelatedPaths = [
        '/recipe-hub',
        '/fridge-recipe',
        '/flyer-recipe',
        '/ingredient-check',
        '/ingredient-check-result',
        '/recipes',
        '/seasonings-settings'
      ];
      return recipeRelatedPaths.some(p =>
        location.pathname === p || location.pathname.startsWith(p + '/')
      );
    }

    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const handleTabClick = (path) => {
    navigate(path);
  };

  return (
    <nav className="tab-nav">
      <div className="tab-nav__container">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-nav__item ${isActive(tab.path) ? 'tab-nav__item--active' : ''}`}
            onClick={() => handleTabClick(tab.path)}
            aria-label={tab.label}
          >
            <div className="tab-nav__indicator"></div>
            <span className="tab-nav__icon">
              <img src={tab.icon} alt={tab.label} className="tab-nav__icon-img" />
            </span>
            <span className="tab-nav__label">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default TabNavigation;
